import { gql } from '@apollo/client'

const AWARD_QUERY = gql`
  query award($id: ID!) {
    award(id: $id) {
      id
      name
      description
      position
      maxPosition
      updatedAt
      updatedBy {
        id
        name
      }
      node {
        id
        name
        isCurationEnabled
        level
        idPath
        namePath
      }
    }
  }
`

export default AWARD_QUERY
